import { render, staticRenderFns } from "./NewNotifications.vue?vue&type=template&id=8f62d2de&scoped=true"
import script from "./NewNotifications.vue?vue&type=script&lang=js"
export * from "./NewNotifications.vue?vue&type=script&lang=js"
import style0 from "./NewNotifications.vue?vue&type=style&index=0&id=8f62d2de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f62d2de",
  null
  
)

export default component.exports